import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    const data = findWork(works, this.props.route.page.path);
    this.galleries = [
      [
        { src: this.prefixPath('osmep-bi-pp-01.jpg') },
        { src: this.prefixPath('osmep-bi-pp-02.jpg') },
        { src: this.prefixPath('osmep-bi-pp-03.jpg') },
        { src: this.prefixPath('osmep-bi-pp-04.jpg') },
        { src: this.prefixPath('osmep-bi-pp-05.jpg') },
        { src: this.prefixPath('osmep-bi-pp-06.jpg') },
        { src: this.prefixPath('osmep-bi-pp-07.jpg') },
        { src: this.prefixPath('osmep-bi-pp-08.jpg') }
      ]
    ];
    
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data}/>
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section-header">
            <PortfolioNextPrevLink data={data} />
            <h2>Description</h2>
          </div>
          <p>
            The Thai Government’s Office of Small and Medium Enterprises Promotion (OSMEP) has been supporting Thai SMEs through several promotional plans each year. In order to roll out effective schemes, OSMEP has been turning a vast amount of data from various sources into useful insights. Formerly, the Database and Statistics Division at OSMEP is responsible for collecting, analyzing and distributing relevant data to other strategic divisions. Due to the diverse demands, the hitherto process involved preparing customized data files on a per-request basis. This not only requires large effort from the database team but also caused data discrepancy from time to time.
          </p>
          <br />
          <p>
            In July 2015, I worked with a team at Runnables to implement a business intelligence platform for OSMEP. The system integrates data from other agencies such as the Department of Business Development (DBD) and the National Statistical Office (TNSO) to produce relevant reports and visualizations. Personnel from all divisions of OSMEP could customize the filters and dimensions on the reports to their needs and export them as spreadsheet files. All report formats could be flexibly customized further by the Database division. In this project, I used Microsft SQL Server Analysis and Reporting Service to implement vital indicators, reports and visualizations. I also designed the front-end web experience used by data consumers.
          </p>
          <br />

          <p>
            Since its deployment in September 2015, the system has experienced over 10,000 report views in 2016 both from OSMEP and other government agencies in Thailand.
          </p>
          <br />


          
        </Container>
          <p className="center">
            The data model in Microsoft SQL Analysis Service
          </p>
          
          <img src={this.prefixPath('osmep-data-model.jpg')} />

        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <p className="center">
            User experience prototype in Power Point.
          </p>
          <br/>
          <Gallery images={this.galleries[0]} />

          

          <img src={this.prefixPath('osmep-screenshots.jpg')} />
          <br /><br />

          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Komthep Saksriyuttana (Project Manager)</li>
              <li>Sarawoot Piya-arayanunt (Full Stack Developer)</li>
              <li>Soravis Prakkamakul (Busiess Analyst, Designer)</li>
            </ul>
          </div>

          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/osmep-business-intelligence/index.jsx
 **/